export default [
    {
        path: "account",
        name: "account",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/index"),
        meta: {
            model: 'account'
        }
    },
    {
        path: "customermanage",
        name: "customermanage",
        component: () => import(/* webpackChunkName: "account" */ "@/views/customermanage/index"),
    },

    // 承运商基础费用
    {
        path: "account/carrierbasecost",
        name: "carrierbasecostList",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/carrierbasecost/index"),
    },
    {
        path: "account/carrierbasecost/update/:type",
        name: "carrierbasecostUpdate",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/carrierbasecost/update"),
    },

    // 客户折扣率
    {
        path: "account/cusdisacountrate",
        name: "cusdisacountrateList",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/cusdisacountrate/index"),
    },
    {
        path: "account/cusdisacountrate/update/:type",
        name: "cusdisacountrateUpdate",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/cusdisacountrate/update"),
    },

    // 客户最低收费
    {
        path: "account/cusminimuncost",
        name: "cusminimuncostList",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/cusminimuncost/index"),
    },
    {
        path: "account/cusminimuncost/update/:type",
        name: "cusminimuncostUpdate",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/cusminimuncost/update"),
    },

    // 承运商分区维护
    {
        path: "account/carrierareamaintain",
        name: "carrierareamaintainList",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/carrierareamaintain/index"),
    },
    {
        path: "account/carrierareamaintain/update/:type",
        name: "carrierareamaintainUpdate",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/carrierareamaintain/update"),
    },

    // 偏远地区邮编
    {
        path: "account/remotezipcode",
        name: "remotezipcodeList",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/remotezipcode/index"),
    },
    {
        path: "account/remotezipcode/update/:type",
        name: "remotezipcodeUpdate",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/remotezipcode/update"),
    },

    // 附加费规则配置
    {
        path: "account/surchargerule",
        name: "surchargeruleList",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/surchargerule/index"),
    },
    {
        path: "account/surchargerule/update/:type",
        name: "surchargeruleUpdate",
        component: () => import(/* webpackChunkName: "account" */ "@/views/account/surchargerule/update"),
    },
]